import React, { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { onAuthStateChanged } from 'firebase/auth'
import { authSolar } from './FirebaseSolar'

const SolarRoutes = () => {
  const navigate = useNavigate()
  const [checking, setChecking] = useState(true)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(authSolar, async (user) => {
      console.log(authSolar.currentUser);
      if (!user || user.isAnonymous) {
        navigate('/Solar-Login', { replace: true })
        return
      }

      const tokenResult = await user.getIdTokenResult(true)
      const role = tokenResult.claims.stripeRole

      if (role !== 'solarPremium') {
        navigate('/Solar-Subscribe', { replace: true })
        return
      }

      setChecking(false)
    })

    return () => unsubscribe()
  }, [navigate])

  if (checking) return null // or spinner

  return <Outlet />
}

export default SolarRoutes